// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"0a20ecf7","703":"51ba1c8f"}[chunkId] + ".chunk.js";
};